//
export const ALL_CLASS_TYPE_LIST = 'ALL_CLASS_TYPE_LIST'
export const ALL_CLASS_TYPE_LIST_SUCCESS = 'ALL_CLASS_TYPE_LIST_SUCCESS'
